<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.catalog" placeholder="状态" @change="list">
            <el-option value="1" label="分组1"></el-option>
            <el-option value="2" label="分组2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" placeholder="状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">Query</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="handleAdd">Add</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="showRewardConfig">奖励配置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column prop="id" label="编号"></el-table-column>

        <el-table-column prop="catalog" label="分组"></el-table-column>

        <el-table-column prop="prizeType" label="奖品类型">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeType === 'goods'">商品</span>
            <span v-if="scope.row.prizeType === 'coupon'">优惠券</span>
            <span v-if="scope.row.prizeType === 'score'">积分</span>
            <span v-if="scope.row.prizeType === 'none'">谢谢参与</span>
          </template>
        </el-table-column>

        <el-table-column prop="prizeData" label="奖品数据"></el-table-column>

        <el-table-column prop="image" label="图片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.image && scope.row.image.url"
              :src="scope.row.image.url"
              :preview-src-list="[scope.row.image.url]"
              style="width: 100px; height: 100px"
              fit="cover"
            />
          </template>
        </el-table-column>

        <el-table-column prop="ratio" label="中奖权重">
          <template slot-scope="scope">{{ scope.row.ratio }}</template>
        </el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">{{ scope.row.status === 0 ? "启用" : "禁用" }}</template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | formatDate }} </template>
        </el-table-column>

        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">{{ scope.row.updateTime | formatDate }} </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="80px">
        <el-form-item label="分组">
          <el-select v-model="addForm.catalog" placeholder="状态">
            <el-option value="1" label="分组1"></el-option>
            <el-option value="2" label="分组2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖品类型">
          <el-select v-model="addForm.prizeType" placeholder="奖品类型">
            <el-option value="goods" label="商品"></el-option>
            <el-option value="coupon" label="优惠券"></el-option>
            <el-option value="score" label="积分"></el-option>
            <el-option value="none" label="谢谢参与"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖品数据">
          <el-input v-model="addForm.prizeData" placeholder="商品ID或积分数量"></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <image-obj-upload v-model="addForm.image" />
        </el-form-item>

        <el-form-item label="中奖权重">
          <el-input-number v-model="addForm.ratio" :min="0"></el-input-number>
        </el-form-item>

        <!--
        <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交 </el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="分组">
          <el-select v-model="editForm.catalog" placeholder="状态">
            <el-option value="1" label="分组1"></el-option>
            <el-option value="2" label="分组2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖品类型">
          <el-select v-model="editForm.prizeType" placeholder="奖品类型">
            <el-option value="goods" label="商品"></el-option>
            <el-option value="coupon" label="优惠券"></el-option>
            <el-option value="score" label="积分"></el-option>
            <el-option value="none" label="谢谢参与"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖品数据">
          <el-input v-model="editForm.prizeData" placeholder="商品ID或积分数量"></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <image-obj-upload v-model="editForm.image" />
        </el-form-item>

        <el-form-item label="中奖权重">
          <el-input-number v-model="editForm.ratio" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit"
          >提交
        </el-button>
      </div>
    </el-dialog>

    <reward-config ref="rewardConfig" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import ImageObjUpload from "@/components/ImageObjUpload";
import RewardConfig from "./reward-config";
import mainHeight from "@/utils/mainHeight";
export default {
  components: { MyPagination, ImageObjUpload, RewardConfig },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        catalog: "1",
        status: 0,
      },
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    showRewardConfig() {
      this.$refs.rewardConfig.open();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/lucky-draw-prize/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        const params = Object.assign({}, this.addForm);
        if (this.addForm.image) {
          params.image = JSON.stringify(this.addForm.image);
        }
        await this.axios.form("base:/api/admin/lucky-draw-prize/create", params);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/lucky-draw-prize/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        const params = Object.assign({}, this.editForm);
        if (this.editForm.image) {
          params.image = JSON.stringify(this.editForm.image);
        }
        await this.axios.form("base:/api/admin/lucky-draw-prize/update", params);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
